import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const RadioCheckbox = ({
    key,
    id,
    name,
    type,
    defaultChecked,
    label,
    children,
    modificators,
    checked,
    ...props
}) => {
    return (
        <label
            key={key}
            htmlFor={id}
            className={classNames(
                "radio-check-box",
                modificators.map(m => `radio-check-box--${m}`)
            )}
        >
            {/*Убрал на пробу */}
            {/*<input type="hidden" name={name} value="0" />*/}

            <input
                id={id}
                key={id}
                type={type}
                name={name}
                value={`1`}
                defaultChecked={defaultChecked}
                checked={checked}
                {...props}
            />

            {label && <span className="radio-check-box__label">{label}</span>}

            {children && <div className="radio-check-box__label">{children}</div>}
        </label>
    );
};
RadioCheckbox.defaultProps = {
    modificators: []
};

RadioCheckbox.propTypes = {
    key: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    type: PropTypes.oneOf(["checkbox", "radio"]),
    defaultChecked: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    children: PropTypes.node,
    modificators: PropTypes.arrayOf(PropTypes.string),
    checked: PropTypes.number,
};

export default RadioCheckbox;
